module.exports = __webpack_public_path__ + "img/github-logo-white.d99d3faa.png";